import { useEffect, type ReactNode } from "react";
import { DEFAULT_PDF_BRAND, setCurrentPdfBrand, type PdfBrand } from "@/utils/pdfBrand";

interface PdfBrandProviderProps {
  brand: PdfBrand;
  children: ReactNode;
}

/**
 * Rend la marque de l'espace actif (Propriétaire / Agence) disponible pour
 * tous les exports PDF générés depuis cet espace. À défaut de fournisseur,
 * les PDF utilisent la marque de la plateforme.
 */
export default function PdfBrandProvider({ brand, children }: PdfBrandProviderProps) {
  useEffect(() => {
    setCurrentPdfBrand(brand);
    return () => setCurrentPdfBrand(DEFAULT_PDF_BRAND);
  }, [brand]);

  return <>{children}</>;
}